import styles from './MapSection.module.css';
import mapImage from '../../../assets/map.png';

type MapSectionProps = {
  readonly label?: string;
};

export const MapSection = ({
  label = '所在地マップ',
}: MapSectionProps): JSX.Element => {
  return (
    <section className={styles.map} aria-label={label}>
      <img className={styles.mapImage} src={mapImage} alt={label} />
      <span className={styles.mapPin} aria-hidden />
    </section>
  );
};
